import router from '@/router';
import Brand from '@/services/Brand';

router.beforeEach(async (to, from, next) => {
     // Use the page's router title to name the page
     if (to.meta && to.meta.title) {
          document.title = `${to.meta.title} | ${Brand.setMetaTitle()}`;
     }

     next();
});
